import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    contacts: 0,
    invoices: 0,
    suppliers: 0,
    purchaseOrders: 0,
    invoiceGroupCount: null
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
